import Vue from 'vue';
import SvgIcon from '../../store-customization-v2/components/SvgIcon.vue';

const init = () => {
    new Vue({
        el: '.payt-triggers-container',
        components: { SvgIcon },
    });
};

if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
            init();
            observer.disconnect();
        }
    }, { rootMargin: '200px' });
    const target = document.querySelector('.payt-triggers-container');
    if (target) {
        observer.observe(target);
    } else {
        init();
    }
} else {
    init();
}
